import { Shield, Home, Waves, Train, Plane, MapPin, TrendingUp, GraduationCap, BellRing, Maximize2 } from "lucide-react";

const IntroStrip = () => {
  return (
    <section className="bg-primary text-primary-foreground py-10 md:py-14">
      <div className="container mx-auto px-6 lg:px-12">
        <p className="font-serif text-center text-xl md:text-2xl lg:text-3xl tracking-wide italic font-light max-w-4xl mx-auto mb-4">
          All around convenience.
        </p>
        <div className="flex justify-center mb-6">
          <div className="w-44 md:w-56 lg:w-64 h-[1px] bg-primary-foreground/60" style={{ clipPath: 'polygon(4px 0, calc(100% - 4px) 0, 100% 50%, calc(100% - 4px) 100%, 4px 100%, 0 50%)' }} />
        </div>
        <p className="font-serif text-center text-lg md:text-xl lg:text-2xl tracking-wide leading-relaxed font-light max-w-4xl mx-auto mb-10">
          Situated within a gated community, Siam Horizon comprises<br />18 thoughtfully designed, premium villas.
        </p>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 lg:gap-14">
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <Shield className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center">
              Gated Community
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <Home className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              18 Turn-Key Villas
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <Maximize2 className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              PLOTS FROM 350<br />UP TO 800 SQM
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <Waves className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              3 km to the Beach
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <BellRing className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              Full-service
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <MapPin className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              Central Location
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <GraduationCap className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              Int'l Schools & Hospitals
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <Train className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              3 km to Train Station
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <Plane className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              Well-Connected
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 min-w-[100px]">
            <TrendingUp className="w-7 h-7 md:w-8 md:h-8 text-accent" />
            <span className="text-xs md:text-sm tracking-widest uppercase text-primary-foreground/80 text-center leading-tight">
              Rising Destination
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroStrip;
